import { badgeBaseDefinition } from '../Badge/badge.common';
import { withStylePrefix } from '../common/withStylePrefix';
import { BadgeCounterComponent, badgeCounterTemplate } from './BadgeCounter';
import styles from './BadgeCounter.styles.scss';
export const badgeCounterDefinition = badgeBaseDefinition('badge-counter', withStylePrefix(styles), badgeCounterTemplate);
export const chameleonBadgeCounter = BadgeCounterComponent.compose(badgeCounterDefinition);
